export default __webpack_public_path__ + "static/media/pembayaran.ae0fde5b.jpeg";